import React from 'react';
import { Helmet } from 'react-helmet-async';

interface SEOProps {
  title?: string;
  description?: string;
  image?: string;
  url?: string;
}

// This component now only handles the title tag and any dynamic content
// All static meta tags are defined in public/index.html for better SEO crawler support
const SEO: React.FC<SEOProps> = ({
  title = 'DIYBuddy - Your AI Assistant for Home Repairs',
  description,
  image,
  url,
}) => {
  return (
    <Helmet>
      {/* Only set the title tag dynamically */}
      <title>{title}</title>
      
      {/* The rest of the meta tags are defined in public/index.html */}
      {/* This ensures they're visible to crawlers that don't execute JavaScript */}
    </Helmet>
  );
};

export default SEO;
